// 詳細パネル v2 共有: 暦日（JST）ベースの「n日前」。
import { fmtYmd } from "../../../../lib/giftingRules";

/** 暦日（JST）の差。iso が今日なら 0・昨日なら 1。解釈できなければ null */
export function calDaysAgo(iso: string | null | undefined, nowIso: string): number | null {
  const a = fmtYmd(iso);
  const b = fmtYmd(nowIso);
  if (!a || !b) return null;
  const [ay, am, ad] = a.split("-").map(Number);
  const [by, bm, bd] = b.split("-").map(Number);
  return Math.round((Date.UTC(by, bm - 1, bd) - Date.UTC(ay, am - 1, ad)) / 86_400_000);
}

/** 「今日」「昨日」「n日前」 */
export function agoLabel(n: number | null): string {
  if (n === null) return "";
  if (n <= 0) return "今日";
  if (n === 1) return "昨日";
  return `${n}日前`;
}
